import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCall, deleteCall, getById } from "../../utils/api";

const initialState = {
  data: [],
  feedbackData: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getFeedback = createAsyncThunk(
  "feedback/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/feedback?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );

      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getFeedbackById = createAsyncThunk(
  "feedback/getById",
  async (id) => {
    try {
      const response = await getById("/admin/v1/feedback", id, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);



export const multipaldeleteFeedback = createAsyncThunk(
  "multipalfeedback/delete",
  async (id, { dispatch }) => {
    try {
      await deleteCall(`/admin/v1/feedback?feedback_id=${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFeedback.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getFeedbackById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFeedbackById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.feedbackData = action.payload;
      })
      .addCase(getFeedbackById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      

      .addCase(multipaldeleteFeedback.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(multipaldeleteFeedback.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (feedback) => feedback.id !== action.payload
        );
      })
      .addCase(multipaldeleteFeedback.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default feedbackSlice.reducer;
